import { getApiBaseUrl, getApiClient } from './serviceconfig';

const apiBaseUrl = getApiBaseUrl();

export async function getDieselConsumptionNumber(cookies, plantId, consumptionDate) {
    const url = `${apiBaseUrl}/diesel_consumptions/consumption_number/?plant_id=${plantId}&consumption_date=${consumptionDate}`;
    return getApiClient(cookies).get(url).then((r) => r.data);
}

export async function getDieselConsumptionList(cookies, params = {}) {
    const query = new URLSearchParams(params).toString();
    const url = query
        ? `${apiBaseUrl}/diesel_consumptions/?${query}`
        : `${apiBaseUrl}/diesel_consumptions/`;
    return getApiClient(cookies).get(url).then((r) => r.data);
}

export async function getDieselConsumptionDetails(cookies, id) {
    return getApiClient(cookies).get(`${apiBaseUrl}/diesel_consumptions/${id}/`).then((r) => r.data);
}

export function createDieselConsumption(cookies, payload) {
    return getApiClient(cookies).post(`${apiBaseUrl}/diesel_consumptions/`, payload).then((r) => r.data);
}

export function updateDieselConsumption(cookies, id, payload) {
    return getApiClient(cookies).put(`${apiBaseUrl}/diesel_consumptions/${id}/`, payload).then((r) => r.data);
}

export function cancelDieselConsumption(cookies, id) {
    return getApiClient(cookies).patch(`${apiBaseUrl}/diesel_consumptions/${id}/`, {}).then((r) => r.data);
}

export function deleteDieselConsumption(cookies, id) {
    return getApiClient(cookies).delete(`${apiBaseUrl}/diesel_consumptions/${id}/`).then((r) => r.data);
}
